import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { pathologyService } from '../services/pathology.service'; 

export const fetchPathologies = createAsyncThunk(
  'pathology/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await pathologyService.getAllPathologies();
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createPathology = createAsyncThunk(
  'pathology/create',
  async (payload, { rejectWithValue }) => {
    try {
      return await pathologyService.createPathology(payload);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePathology = createAsyncThunk(
  'pathology/update',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await pathologyService.updatePathology(id, payload);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePathology = createAsyncThunk(
  'pathology/delete',
  async (id, { rejectWithValue }) => {
    try {
      return await pathologyService.deletePathology(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pathologySlice = createSlice({
  name: 'pathology',
  initialState: {
    pathologies: [],
    loading: false,
    actionStatus: 'idle',
    error: null,
  },
  reducers: {
    resetActionStatus: (state) => {
      state.actionStatus = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPathologies.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPathologies.fulfilled, (state, action) => {
        state.loading = false;
        state.pathologies = action.payload;
      })
      .addCase(fetchPathologies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPathology.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(createPathology.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(updatePathology.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(updatePathology.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(deletePathology.fulfilled, (state, action) => {
        state.pathologies = state.pathologies.filter(
          (p) => p.pathologyId !== action.payload
        );
      });
  },
});

export const { resetActionStatus } = pathologySlice.actions;
export default pathologySlice.reducer;